
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { Button } from '@/components/ui/button';
import { Map } from 'lucide-react';

interface TourMapSectionProps {
  tour: {
    id: string;
    mapType?: 'indoor' | 'outdoor';
    mapImage?: string;
  };
}

export const TourMapSection: React.FC<TourMapSectionProps> = ({ tour }) => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  
  // Only show the map section if there's actually a map available
  const hasMap = tour.mapType === 'outdoor' || (tour.mapType === 'indoor' && tour.mapImage);
  
  // Don't render anything if no map is available
  if (!hasMap) {
    return null;
  }
  
  const handleMapClick = () => {
    navigate(`/tour-map/${tour.id}`);
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm mb-8">
      <div className="text-center">
        <Button 
          variant="outline" 
          onClick={handleMapClick}
          className="flex items-center gap-2"
        >
          <Map size={16} />
          {language === 'en' ? 'View Tour Map' : 'צפה במפת הסיור'}
        </Button>
      </div>
    </div>
  );
};
